import { SxProps, Typography } from '@mui/material'
import { FC } from 'react'

export const KomejirushiMongon: FC<{ text: string; sx?: SxProps }> = ({ text, sx }) => {
  return (
    <Typography variant="body2" sx={{ fontWeight: 'bold', ...sx }}>
      ※ {text}
    </Typography>
  )
}
